/**
 * Converts a given string into a URL-friendly slug.
 *
 * - Removes all non-word characters.
 * - Converts the string to lowercase.
 * - Replaces spaces with hyphens.
 * - Trims leading and trailing hyphens.
 *
 * @param str - The input string to be slugified. If `undefined`, returns an empty string.
 * @returns The slugified version of the input string.
 */
export default function textSlugify(str: string | undefined): string {
  if (str === undefined) return "";
  // Replace accented characters with their ASCII equivalents
  str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  // Remove all non-word characters except hyphens, and convert to lowercase
  str = str.replace(/[^\w\s-]/gi, "").toLowerCase();
  // Replace spaces with hyphens
  str = str.replace(/\s+/g, "-");

  // Remove any leading or trailing hyphens
  str = str.replace(/^-+|-+$/g, "");

  return str;
}
